export default [
  {
    "id": "mat-enem-0602",
    "numero": 2102,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Todos os anos são registrados milhares de aci-\ndentes nas rodovias. Um número significativo \ndesses acidentes ocorre no período de carna-\nval. De acordo com a Polícia Rodoviária Federal \n(PRF), o número de acidentes registrados no \ncarnaval teve uma redução de 4 312, registra-\ndos em 2011, para 3 345 em 2012. O quadro \nmostra os números registrados de alguns esta-\ndos brasileiros. \n \n \n \nDe acordo com o quadro apresentado, o estado \nque apresentou maior queda percentual no nú-\nmero de acidentes foi: \n \nA) Santa Catarina. \nB) Rio de Janeiro. \nC) Pernambuco. \nD) Pará. \nE) Mato Grosso.",
    "alternativas": {
      "E": "Mato Grosso.",
      "A": "Santa Catarina.",
      "B": "Rio de Janeiro.",
      "C": "Pernambuco."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 602,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0603",
    "numero": 2103,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Em uma cidade turística, três hotéis ofereceram \npromoções para o mês de abril de 2011 e com-\npararam as taxas de ocupação nesse mês com \nas de abril de 2010. Os descontos praticados \nestão descritos a seguir: \n \n• Hotel 1: Foi dado um desconto de 10% nas \ndiárias, elevando a ocupação de 70% em 2010 \npara 80% em 2011  \n• Hotel 2: Foi dado um desconto de 15% nas \ndiárias, elevando a ocupação de 60% em 2010 \npara 100% em 2011.  \n \n• Hotel 3: Foi dado um desconto de 20% nas \ndiárias, elevando a ocupação de 10% em 2010 \npara 60% em 2011.  \n \n• Hotel 4: Foi dado um desconto de 25% nas \ndiárias, elevando a ocupação de 30% em 2010 \npara 90% em 2011.  \n \n• Hotel 5: Foi dado um desconto de 30% nas \ndiárias, elevando a ocupação de 40% em 2010 \npara 60% em 2011.  \n \nApós o término de 2011, foi feita uma avaliação \nsobre os impactos desses descontos nos valo-\nres arrecadados pelos hotéis. O hotel que apre-\nsentou a maior diferença na taxa de arrecada-\nção de 2010 para 2011 foi o: \n \nA) hotel 1, pois apresenta a maior taxa de ocu-\npação antes dos descontos. \nB) hotel 2, pois apresenta a maior taxa de ocu-\npação após os descontos. \nC) hotel 3, pois apresenta aumento de 38% na \ntaxa de arrecadação. \nD) hotel 4, pois apresenta a maior diferença na \ntaxa de arrecadação de 2010 para 2011. \nE) hotel 5, pois apresenta o maior desconto no \nvalor da diária.",
    "alternativas": {
      "A": "hotel 1, pois apresenta a maior taxa de ocu- pação antes dos descontos.",
      "B": "hotel 2, pois apresenta a maior taxa de ocu- pação após os descontos.",
      "C": "hotel 3, pois apresenta aumento de 38% na taxa de arrecadação.",
      "E": "hotel 5, pois apresenta o maior desconto no valor da diária."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 603,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0604",
    "numero": 2104,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um jogo entre dois jogadores tem as seguintes \nregras: (a) o primeiro jogador pensa em uma \nforma geométrica, desenha apenas uma parte \nda forma e fornece uma dica para que o segun-\ndo jogador termine o desenho; (b) se o segundo \njogador conseguir concluir o desenho, ganha \num ponto; caso contrário, quem ganha um ponto \né o primeiro jogador. Dois amigos, Alberto e \nDora, estão jogando o referido jogo. Alberto \ndesenhou a figura a seguir e deu a seguinte \ndica a Dora: \"a forma em que pensei é a planifi-\ncação de um prisma reto\". \n \n \n \nDora completou o desenho com: \n \nA) um pentágono e um retângulo. \nB) um pentágono e quatro retângulos. \nC) um pentágono e cinco retângulos. \nD) dois pentágonos e quatro retângulos. \nE) dois pentágonos e cinco retângulos.",
    "alternativas": {
      "B": "um pentágono e quatro retângulos.",
      "C": "um pentágono e cinco retângulos.",
      "D": "dois pentágonos e quatro retângulos.",
      "A": "um pentágono e um retângulo."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 604,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0605",
    "numero": 2105,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um estudo feito em cidades brasileiras aponta \nque apenas 15% dos diabéticos do país fazem \nbom controle da doença. A pesquisa, que foi \nfeita por meio da análise dos prontuários e \nquestionários respondidos por pacientes entre \n2008 e 2010, analisou os dados de 3580 pesso-\nas de 20 cidades nas cinco regiões do Brasil.  \n \nEntre todos que participaram da pesquisa, qual \né o número de pessoas que fazem um bom \ncontrole do diabetes? \n \nA) 27 \nB) 53 \nC) 239 \nD) 537 \nE) 1 074",
    "alternativas": {
      "D": "537",
      "E": "1 074",
      "B": "53",
      "C": "239"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 605,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0606",
    "numero": 2106,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A velocidade Mach (M) de um avião é definida \ncomo a razão entre a velocidade do avião e a \nvelocidade do som. Os aviões são classificados \nem categorias, de acordo com a velocidade que \nconseguem atingir.  \n \nAs categorias são: subsônica (M < 1,0), transô-\nnica (1,0 ≤ M < 1,2), supersônica (1,2 M ≤ 5,0) e \nhipersônica (1,2 ≤ M <5,0). Considere a veloci-\ndade do som igual a 1200 km/h.  \n \nJoão e Bia fizeram uma viagem de avião, que \npercorreu 3600 km em 4 horas.  \n \nBia disse que esse avião era muito rápido e, \nportanto, supersônico. João convenceu Bia de \nque ela estava errada, argumentando que, para \no avião ser supersônico, o tempo de sua viagem \ndeveria ser reduzido em, no mínimo, \n \nA) 1,0 h. \nB) 1,5 h. \nC) 1,6 h. \nD) 2,4 h. \nE) 2,5 h.",
    "alternativas": {
      "A": "1,0 h.",
      "B": "1,5 h.",
      "D": "2,4 h.",
      "E": "2,5 h."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 606,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0607",
    "numero": 2107,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Em 2010, o mundo produziu uma quantidade de \nalimentos adequada para 5,5 bilhões de pesso-\nas. A população mundial era de 6,5 bilhões e 1 \nbilhão de pessoas passou fome, segundo a \nFAO. Em 2050, estimativas indicam que a popu-\nlação mundial será de nove bilhões, ou seja, \nserá preciso aumentar bastante a oferta de ali-\nmentos nos próximos 40 anos.  \n \nConsidere que a quantidade de alimentos pro-\nduzidos em 2050 seja 40% superior à de 2010. \nDe acordo com os dados e estimativas apresen-\ntados, a quantidade de pessoas, em bilhões, \nque passará fome em 2050, será igual a: \n \nA) 1,2. \nB) 1,3. \nC) 1,4. \nD) 2,2. \nE) 2,3.",
    "alternativas": {
      "B": "1,3.",
      "D": "2,2.",
      "E": "2,3.",
      "A": "1,2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 607,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0608",
    "numero": 2108,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Em uma determinada estrada existem dois tele-\nfones instalados no acostamento: um no quilo-\nmetro 30 e outro no quilômetro 480. Entre eles \nserão colocados mais 8 telefones, mantendo-se \nentre dois telefones consecutivos sempre a \nmesma distância. Qual a sequência numérica \nque corresponde à quilometragem em que os \nnovos telefones serão instalados? \n \nA) 30, 90, 150, 210, 270, 330, 390, 450 \nB) 75, 120, 165, 210, 255, 300, 345, 390 \nC) 78, 126, 174, 222, 270, 318, 366, 414 \nD) 80, 130, 180, 230, 280, 330, 380, 430 \nE) 81, 132, 183, 234, 285, 336, 387, 438",
    "alternativas": {
      "A": "30, 90, 150, 210, 270, 330, 390, 450",
      "B": "75, 120, 165, 210, 255, 300, 345, 390",
      "C": "78, 126, 174, 222, 270, 318, 366, 414",
      "D": "80, 130, 180, 230, 280, 330, 380, 430"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 608,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0609",
    "numero": 2109,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Tanto na natureza, quanto na indústria, existem \ndiversos tipos de fluidos. Fluidos Newtonianos \nsão aqueles que apresentam crescimento linear \nda tensão cisalhante com relação ao gradiente \nde velocidade, com coeficiente angular não \nnulo. Apresentam ainda tensão cisalhante nula \ncom gradiente de velocidade zero. Afigura apre-\nsenta a relação da tensão cisalhante com o \ngradiente de velocidade para diversos tipos de \nfluidos. \n \n \n \nDentre as curvas da figura, determine qual(is) \né(são) de fluido(s) Newtoniano(s). \n \nA) A \nB) B \nC) C \nD) D \nE) A e C",
    "alternativas": {
      "C": "C",
      "D": "D",
      "A": "A",
      "B": "B"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 609,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0610",
    "numero": 2110,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um indivíduo possui uma renda mensal de \nR$1200,00 e deseja comprar um refrigerador. \nNa loja que ele decide fazer sua compra, o refri-\ngerador custa R$1800,00.  \n \nEsse valor deverá ser pago em 12 prestações \nmensais iguais e sem juros. Uma forma de re-\npresentar a quantia da renda mensal do indiví-\nduo que será usada para pagar cada prestação \né: \n \nA) 1/18 \nB) 1/12 \nC) 1/8 \nD) 2/3 \nE) 3/2",
    "alternativas": {
      "B": "1/12",
      "C": "1/8",
      "D": "2/3",
      "E": "3/2"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 610,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0611",
    "numero": 2111,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O filme A corrente do bem conta a história de \num jovem que crê ser possível mudar o mundo \na partir da ação voluntária de cada um. A ideia é \nbaseada em três premissas: fazer por alguém \nalgo que este não pode fazer por si mesmo; \nfazer isso para três pessoas; cada pessoa aju-\ndada deve fazer isso por outras três pessoas. \nDa mesma forma que temos a \"corrente do \nbem\" para 3 pessoas, podemos ter uma corren-\nte do bem para um número qualquer de pesso-\nas.  \n \nSuponha que uma corrente do bem seja iniciada \nnuma segunda-feira, com X pessoas sendo \najudadas, e que cada uma dessas X pessoas \najudasse outras X pessoas exatamente 24 ho-\nras após ter recebido a ação voluntária.  \n \nPara termos um total de 42 pessoas ajudadas \nao término da terça-feira o número X deve ser \nigual a: \n \nA) 2. \nB) 6. \nC) 7. \nD) 14. \nE) 21.",
    "alternativas": {
      "B": "6.",
      "D": "14.",
      "E": "21.",
      "A": "2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 611,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0612",
    "numero": 2112,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Desde 2005, o Banco Central não fabrica mais a \nnota de 1real e, desde então, só produz dinheiro \nneste valor em moedas. Hoje, há pouco mais de \n159 milhões de cédulas de 1 real em circulação \nno Brasil, contra 1,6 bilhão de moedas do mes-\nmo valor. O Brasil chegou a ter 1 bilhão de cé-\ndulas de 1 real em circulação, mas o número só \ndiminui com o tempo.  \n \nApesar de ser mais caro produzir uma moeda, a \ndurabilidade do metal é 30 vezes maior que a \ndo papel. Fabricar uma moeda de R$ 1 custa \nR$ 0,26, enquanto a nota custava R$ 0,17, en-\ntretanto, a cédula durava de oito a 11 meses. O \ntempo mínimo de durabilidade da moeda é: \n \nA) 20 anos. \nB) 28 anos. \nC) 30 anos. \nD) 240 anos. \nE) 330 anos.",
    "alternativas": {
      "E": "330 anos.",
      "A": "20 anos.",
      "B": "28 anos.",
      "D": "240 anos."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 612,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0613",
    "numero": 2113,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Em uma plantação de eucaliptos, um fazendeiro \naplicará um fertilizante a cada 40 dias, um inse-\nticida para combater as formigas a cada 32 dias \ne um pesticida a cada 28 dias. Ele iniciou apli-\ncando os três produtos em um mesmo dia.  \n \nDe acordo com essas informações, depois de \nquantos dias, após a primeira aplicação, os três \nprodutos serão aplicados novamente no mesmo \ndia? \n \nA) 100 \nB) 140 \nC) 400 \nD) 1120 \nE) 35840",
    "alternativas": {
      "B": "140",
      "C": "400",
      "D": "1120",
      "A": "100"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 613,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0614",
    "numero": 2114,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A fim de expandir seus investimentos, um banco \nestá avaliando os resultados financeiros de du-\nas seguradoras de veículos de uma cidade.  \n \nO seguro de um carro custa, em média, R$ \n2000,00 na seguradora X e R$ 3000,00 na se-\nguradora Y; já o valor pago pela seguradora a \num cliente, vítima de roubo, é de R$ 42000,00 \nna seguradora X e de R$ 63000,00 na segura-\ndora Y.  \n \nPesquisas revelam que, nesta cidade, a proba-\nbilidade de um veículo ser roubado é de 1%.  \n \nSabe-se que essas duas seguradoras têm a \nmesma quantidade de clientes e que o banco \noptará pela seguradora que possuir o maior \nlucro médio por veículo.  \n \nA seguradora escolhida pelo banco e o lucro \nmédio por veículo nessa escolha serão, respec-\ntivamente, \n \nA) Y e R$ 2970,00. \nB) Y e R$ 2370,00. \nC) Y e R$ 2340,00. \nD) X e R$ 1580,00. \nE) X e R$ 1560,00.",
    "alternativas": {
      "A": "Y e R$ 2970,00.",
      "B": "Y e R$ 2370,00.",
      "C": "Y e R$ 2340,00.",
      "D": "X e R$ 1580,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 614,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0615",
    "numero": 2115,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Um conjunto residencial será construído em um \nterreno que está representado no mapa a seguir \nna escala 1:1000. O terreno está divido em lotes \nquadrados iguais ao indicado na figura. No lo-\ncal, será construído um centro comunitário, qui-\nosques e praças de lazer e alimentação, de tal \nforma que a soma total dessas áreas não ultra-\npasse 2/5 da área total do terreno. \n \n \n \nA área total, a ser disponibilizada para a cons-\ntrução do centro comunitário, dos quiosques e \ndas praças de lazer e alimentação, não poderá \nultrapassar: \n \nA) 40.000 m2. \nB) 4.000 m2. \nC) 400 m2. \nD) 40 m2. \nE) 4 m2.",
    "alternativas": {
      "D": "40 m2.",
      "E": "4 m2.",
      "A": "40.000 m2.",
      "C": "400 m2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 615,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0617",
    "numero": 2117,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O número de pessoas que morrem nas ruas e \nestradas brasileiras nunca foi tão alto. As últi-\nmas mudanças na legislação mostraram-se \nincapazes de frear o aumento dos acidentes. O \nnúmero de mortes em 2004 foi de 35100 pesso-\nas e 38300, em 2008. Admita que o número de \nmortes, no período de 2004 a 2008, tenha apre-\nsentado um crescimento anual constante.  \n \nA expressão algébrica que fornece o número de \nmortes N, no ano x (com 2004 ≤ x ≤ 2008), é \ndada por: \nA) N = 800x + 35100 \nB) N = 800(x - 2004) + 35100 \nC) N = 800(x - 2004) \nD) N = 3200(x - 2004) + 35100 \nE) N = 3200x + 35100",
    "alternativas": {
      "E": "N = 3200x + 35100",
      "A": "N = 800x + 35100",
      "B": "N = 800(x - 2004) + 35100",
      "D": "N = 3200(x - 2004) + 35100"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 617,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0618",
    "numero": 2118,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O gráfico a seguir mostra a evolução da taxa de \ndesemprego (ou seja, a porcentagem da popu-\nlação economicamente ativa que está desem-\npregada) nas seis principais regiões metropoli-\ntanas brasileiras nos meses de julho de 2006 a \njulho de 2011. \n \n \n \nSuponha que a razão entre as taxas de desem-\nprego de julho de 2010 e julho de 2011 seja \nigual à razão entre a taxa de desemprego de \njulho de 2011 e julho de 2012. A taxa de de-\nsemprego em julho de 2012 será um número \nentre: \n \nA) 4,0 e 4,5. \nB) 5,0 e 5,5. \nC) 5,5 e 6,1. \nD) 6,0 e 6,6. \nE) 6,6 e 7,1.",
    "alternativas": {
      "A": "4,0 e 4,5.",
      "B": "5,0 e 5,5.",
      "C": "5,5 e 6,1.",
      "E": "6,6 e 7,1."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 618,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0619",
    "numero": 2119,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O quadro a seguir indica a quantidade de meda-\nlhas obtidas por atletas brasileiros nos Jogos \nOlímpicos de 1976 a 2008. \n \n \nA mediana e a média do número de medalhas \nobtidas pelos atletas brasileiros nos Jogos \nOlímpicos de 1976 a 2008 são, respectivamen-\nte, iguais a: \n \nA) 7 e 7,5. \nB) 7 e 8,3. \nC) 8 e 7,5. \nD) 8 e 8,3. \nE) 15 e 8,3.",
    "alternativas": {
      "D": "8 e 8,3.",
      "A": "7 e 7,5.",
      "B": "7 e 8,3.",
      "C": "8 e 7,5."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 619,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0620",
    "numero": 2120,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A legislação brasileira estabelece vários impos-\ntos para que o Estado levante os recursos ne-\ncessários para custear os investimentos e des-\npesas de responsabilidade do setor público. A \narrecadação do Brasil, nas três esferas da ad-\nministração pública (municípios, estados e Uni-\não), vem aumentando consideravelmente nos \núltimos anos. No ano de 2005, foram arrecada-\ndos cerca de 700 bilhões de reais. A evolução \ndo crescimento da arrecadação até 2010, em \nporcentagem, está expressa na tabela a seguir. \n \n \n \nDe acordo com os dados apresentados, infere-\nse que o valor mais aproximado da arrecadação \nbrasileira do setor público do ano de 2007 foi, \nem bilhões de reais, de: \n \nA) 724. \nB) 738. \nC) 784. \nD) 868. \nE) 878.",
    "alternativas": {
      "B": "738.",
      "C": "784.",
      "D": "868.",
      "E": "878."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 620,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0621",
    "numero": 2121,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Em Economia, costuma-se representar o con-\nsumo mensal C de uma família por uma função \nlinear C = c0 + c1Y, em que c0 é o consumo in-\ndependente da renda, c1 é a chamada propen-\nsão ao consumo e Y é a renda mensal da famí-\nlia.  \n \nUma determinada família possui a seguinte \nfunção consumo: C = 500 + 0,8Y. Nesse caso, \nela possui um gasto de R$500,00, independente \nda renda, e propensão ao consumo de 0,8. \nNessa família, a renda mensal provém somente \ndos salários do pai e da mãe, que são, respecti-\nvamente, R$ 3000,00 e R$ 4000,00 \n \nQual o consumo mensal dessa família? \n \nA) R$ 2900,00. \nB) R$ 3300,00. \nC) R$ 3700,00. \nD) R$ 6100,00. \nE) R$ 6600,00.",
    "alternativas": {
      "D": "R$ 6100,00.",
      "E": "R$ 6600,00.",
      "A": "R$ 2900,00.",
      "C": "R$ 3700,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 621,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0622",
    "numero": 2122,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O Índice Nacional de Preços ao Consumidor \nAmplo (IPCA) mede a variação dos custos dos \ngastos no período do primeiro ao último dia de \ncada mês de referência. O quadro a seguir mos-\ntra informações sobre o IPCA dos meses de \njaneiro a outubro de 2011. \n \n \n \nDe acordo com as informações dadas, a media-\nna e a média aritmética do IPCA, de janeiro a \noutubro de 2011, são, respectivamente, \n \nA) 0,53 e 0,50. \nB) 0,50 e 0,53. \nC) 0,50 e 0,49. \nD) 0,49 e 0,50. \nE) 0,49 e 0,53.",
    "alternativas": {
      "A": "0,53 e 0,50.",
      "B": "0,50 e 0,53.",
      "D": "0,49 e 0,50.",
      "E": "0,49 e 0,53."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 622,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0623",
    "numero": 2123,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Na figura, estão indicadas as medidas reais da \nlargura e do comprimento de uma casa. \n \n \nUm arquiteto fez a planta dessa casa numa \nfolha de papel retangular utilizando a escala \n1:30, deixando 6 cm em cada uma das margens \nda folha (direita, esquerda, inferior e superior).  \n \nQuais são, respectivamente, o comprimento e a \nlargura, em centímetros, da folha de papel utili-\nzada? \n \nA) 50 e 30 \nB) 50 e 42 \nC) 56 e 36 \nD) 62 e 30 \nE) 62 e 42",
    "alternativas": {
      "E": "62 e 42",
      "A": "50 e 30",
      "B": "50 e 42",
      "C": "56 e 36"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 623,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0625",
    "numero": 2125,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "No ano de 2011, o sul do país foi castigado por \numa forte estiagem. Para amenizar essa situa-\nção, a prefeitura de um município dessa região \nutilizou um caminhão pipa, com capacidade de \n32 mil litros de água para abastecer as residên-\ncias de uma localidade desse município. Nessa \nlocalidade, com o caminhão pipa cheio, foram \nrealizados 3 abastecimentos de água. No pri-\nmeiro, foram distribuídos 1/4 da capacidade de \nágua do caminhão e, no segundo 1/3 do restan-\nte.  \n \nConsiderando-se que não houve desperdício de \nágua durante o abastecimento e que o restante \ntenha sido utilizado totalmente, a fração da ca-\npacidade de água do caminhão pipa, distribuída \nno terceiro abastecimento, foi: \n \nA) 2/7 \nB) 1/3 \nC) 5/12 \nD) 1/2 \nE) 7/12",
    "alternativas": {
      "D": "1/2",
      "E": "7/12",
      "B": "1/3",
      "C": "5/12"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 625,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0626",
    "numero": 2126,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Os egípcios da Antiguidade criaram um sistema \nmuito interessante para escrever números ba-\nseado em agrupamento. \n \nO número 1 é representado pelo bastão |, o \nnúmero 2 por dois bastões | | e assim por dian-\nte, até o número 9, representado por noves \nbastões em sequência | | | | | | | | |. Para o núme-\nro 10, utiliza-se o símbolo \n e alguns outros \nnúmeros múltiplos de 10 estão descritos na \ntabela a seguir. \n \n \n \nOs números de 1 a 9999999 na numeração \negípcia derivam dos símbolos da tabela, respei-\ntando as devidas quantidades e posições (sím-\nbolos que representam números maiores são \ncolocados à esquerda e de maneira decrescen-\nte, são colocados os demais símbolos à direita, \naté a soma deles chegar ao número desejado). \nPor exemplo, o número 321 é descrito por \n, pois 100+100+100+10+10+1 é igual a \n321. \n \nO número egípcio \n \nequivale ao número: \n \nA) 12372 \nB) 1230072 \nC) 1203702 \nD) 1230702 \nE) 1237200",
    "alternativas": {
      "E": "1237200",
      "A": "12372",
      "C": "1203702",
      "D": "1230702"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 626,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0627",
    "numero": 2127,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A cada dia que passa, um aluno resolve 2 exer-\ncícios a mais do que resolveu no dia anterior. \nEle completou seu 11º dia de estudo e resolveu \n22 exercícios. Seu objetivo é resolver, no total, \npelo menos 272 exercícios.  \n \nMantendo seu padrão de estudo, quantos dias \nele ainda precisa para atingir sua meta? \n \nA) 5 \nB) 6 \nC) 9 \nD) 16 \nE) 20",
    "alternativas": {
      "D": "16",
      "E": "20",
      "A": "5",
      "B": "6"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 627,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0628",
    "numero": 2128,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A quantidade de certa espécie de crustáceos, \nmedida em toneladas, presente num trecho de \nmangue, foi modelada pela equação: \n \n \n \nOnde t representa o número de meses transcor-\nridos após o início de estudo e w é uma cons-\ntante. \n \nO máximo e o mínimo de toneladas observados \ndurante este estudo são, respectivamente, \n \nA) 600 e 100 \nB) 600 e 150 \nC) 300 e 100 \nD) 300 e 60 \nE) 100 e 60",
    "alternativas": {
      "A": "600 e 100",
      "B": "600 e 150",
      "C": "300 e 100",
      "D": "300 e 60"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 628,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0629",
    "numero": 2129,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "O Ibope entrevistou 100 pessoas que assistiram \nà estreia da versão 2011 do Rock in Rio, no dia \n23 de setembro de 2011, sendo que os entrevis-\ntados atribuíram uma nota de 0 (zero) a 10 (dez) \npara o dia da estreia do evento.  \nA média das notas dos entrevistados foi 9,3 e \n64 pessoas deram nota 10 ao evento no dia de \nestreia. \n \nDesta forma, a melhor aproximação para a mé-\ndia das demais notas (diferentes de 10) do dia \nde estreia foi: \n \nA) 8,05. \nB) 8,60. \nC) 9,30. \nD) 9,65. \nE) 9,75.",
    "alternativas": {
      "A": "8,05.",
      "B": "8,60.",
      "C": "9,30.",
      "D": "9,65."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 629,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0630",
    "numero": 2130,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "A forma e as dimensões de um campo de jogo \npara o futebol são estabelecidas pelo Instituto \nNacional de Metrologia (INMETRO), definindo \nno documento Regras do Jogo que o campo \nseja retangular e que possua os limites máxi-\nmos e mínimos para largura e comprimento \napresentados na figura a seguir. Estabelece \ntambém que o campo deve ser dividido em duas \nmetades iguais e que o ponto central deve estar \nlocalizado no centro do campo. Qualquer campo \nque atenda a estes requisitos é considerado \noficial. \n \nPara a irrigação da área gramada do campo de \njogo em determinada região do país são gastos, \nem média, 6 litros de água por metro quadrado \npor dia. \n \n \n \nQual será a economia semanal de água de irri-\ngação, em litros, de um campo de futebol oficial \nque possua as dimensões mínimas de compri-\nmento e de largura, em relação a um campo \nconstruído com as dimensões máximas? \n \nA) 24300. \nB) 64800. \nC) 170100. \nD) 283500. \nE) 453600",
    "alternativas": {
      "B": "64800.",
      "C": "170100.",
      "D": "283500.",
      "E": "453600"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2014.3",
    "numeroOriginal": 630,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0631",
    "numero": 2131,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um estudante está pesquisando o desenvolvi-\nmento de certo tipo de bactéria. Para essa pes-\nquisa, ele utiliza uma estufa para armazenar as \nbactérias. A temperatura no interior dessa estu-\nfa, em graus Celsius, é dada pela expressão \nT(h) = – h2 + 22h – 85, em que h representa as \nhoras do dia. Sabe-se que o número de bacté-\nrias é o maior possível quando a estufa atinge \nsua temperatura máxima e, nesse momento, ele \ndeve retirá-las da estufa. A tabela associa inter-\nvalos de temperatura, em graus Celsius, com as \nclassificações: muito baixa, baixa, média, alta e \nmuito alta. \n \n \n \nQuando o estudante obtém o maior número \npossível de bactérias, a temperatura no interior \nda estufa está classificada como: \n \nA) muito baixa.  \nB) baixa.  \nC) média. \nD) alta.  \nE) muito alta.",
    "alternativas": {
      "A": "muito baixa.",
      "C": "média.",
      "D": "alta.",
      "E": "muito alta."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 631,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0632",
    "numero": 2132,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "A figura representa a vista superior de uma bola \nde futebol americano, cuja forma é um elipsoide \nobtido pela rotação de uma elipse em torno do \neixo das abscissas. Os valores a e b são, res-\npectivamente, a metade do seu comprimento \nhorizontal e a metade do seu comprimento ver-\ntical. Para essa bola, a diferença entre os com-\nprimentos horizontal e vertical é igual à metade \ndo comprimento vertical. \n \n \n \nConsidere que o volume aproximado dessa bola \né dado por V = 4ab2. \n \nO volume dessa bola, em função apenas de b, é \ndado por: \nA) 8b3 \nB) 6b3  \nC) 5b3  \nD) 4b3  \nE) 2b3",
    "alternativas": {
      "D": "4b3",
      "E": "2b3",
      "A": "8b3",
      "B": "6b3"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 632,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0634",
    "numero": 2134,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Um investidor inicia um dia com x ações de uma \nempresa. No decorrer desse dia, ele efetua \napenas dois tipos de operações, comprar ou \nvender ações. Para realizar essas operações, \nele segue estes critérios: \n \nI. Vende metade das ações que possui, assim \nque seu valor fica acima do valor ideal (Vi); \n \nII. Compra a mesma quantidade de ações que \npossui, assim que seu valor fica abaixo do va-\nlor mínimo (Vm); \n \nIII. Vende todas as ações que possui, quando \nseu valor fica acima do valor ótimo (Vo). \n \nO gráfico apresenta o período de operações e a \nvariação do valor de cada ação, em reais, no \ndecorrer daquele dia e a indicação dos valores \nideal, mínimo e ótimo. \n \n \nQuantas operações o investidor fez naquele \ndia? \n \nA) 3  \nB) 4  \nC) 5  \nD) 6  \nE) 7",
    "alternativas": {
      "A": "3",
      "B": "4",
      "C": "5",
      "D": "6"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 634,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0635",
    "numero": 2135,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O tampo de vidro de uma mesa quebrou-se e \ndeverá ser substituído por outro que tenha a \nforma de círculo. O suporte de apoio da mesa \ntem o formato de um prisma reto, de base em \nforma de triângulo equilátero com lados medin-\ndo 30 cm. Uma loja comercializa cinco tipos de \ntampos de vidro circulares com cortes já padro-\nnizados, cujos raios medem 18 cm, 26 cm, 30 \ncm, 35 cm e 60 cm. O proprietário da mesa \ndeseja adquirir nessa loja o tampo de menor \ndiâmetro que seja suficiente para cobrir a base \nsuperior do suporte da mesa. \n \nConsidere 1,7 como aproximação para √3. \n \nO tampo a ser escolhido será aquele cujo raio, \nem centímetros, é igual a: \n \nA) 18.  \nB) 26.  \nC) 30.  \nD) 35.  \nE) 60.",
    "alternativas": {
      "D": "35.",
      "E": "60.",
      "A": "18.",
      "C": "30."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 635,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0636",
    "numero": 2136,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Atualmente existem diversas locadoras de veí-\nculos permitindo uma concorrência saudável \npara o mercado fazendo com que os preços se \ntornem acessíveis. Nas locadoras P e Q, o valor \nda diária de seus carros depende da distância \npercorrida, conforme o gráfico. \nO valor pago na locadora Q é menor ou igual \nàquele pago na locadora P para distâncias, em \nquilômetros, presentes em qual(is) intervalo(s)? \n \nA) De 20 a 100. \nB) De 80 a 130. \nC) De 100 a 160. \nD) De 0 a 20 e de 100 a 160. \nE) De 40 a 80 e de 130 a 160.",
    "alternativas": {
      "C": "De 100 a 160.",
      "D": "De 0 a 20 e de 100 a 160.",
      "E": "De 40 a 80 e de 130 a 160.",
      "A": "De 20 a 100."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 636,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0637",
    "numero": 2137,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Numa cidade, cinco escolas de samba (I, II, III, \nIV e V) participaram do desfile de Carnaval. \nQuatro quesitos são julgados, cada um por dois \njurados, que podem atribuir somente uma den-\ntre as notas 6, 7, 8, 9 ou 10. A campeã será a \nescola que obtiver mais pontuação na soma de \ntodas as notas emitidas. Em caso de empate, a \ncampeã será a que alcançar a maior soma das \nnotas atribuídas pelos jurados no quesito Enre-\ndo e Harmonia. A tabela mostra as notas do \ndesfile desse ano no momento em que faltava \nsomente a divulgação das notas do jurado B no \nquesito Bateria. \n \n \n \nQuantas configurações distintas das notas a \nserem atribuídas pelo jurado B no quesito Bate-\nria tornariam campeã a Escola II? \n \nA) 21  \nB) 90  \nC) 750 \nD) 1250  \nE) 3125",
    "alternativas": {
      "C": "750",
      "E": "3125",
      "A": "21",
      "B": "90"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 637,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0638",
    "numero": 2138,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "No contexto da matemática recreativa, utilizan-\ndo diversos materiais didáticos para motivar \nseus alunos, uma professora organizou um jogo \ncom um tipo de baralho modificado, No início do \njogo, vira-se uma carta do baralho na mesa e \ncada jogador recebe em mãos nove cartas. \nDeseja-se formar pares de cartas, sendo a pri-\nmeira carta a da mesa e a segunda, uma carta \nna mão do jogador, que tenha um valor equiva-\nlente àquele descrito na carta da mesa. O obje-\ntivo do jogo é verificar qual jogador consegue o \nmaior número de pares. Iniciado o jogo, a carta \nvirada na mesa e as cartas da mão de um joga-\ndor são como no esquema: \n \n \n \nSegundo as regras do jogo, quantas cartas da \nmão desse jogador podem formar um par com a \ncarta da mesa? \n \nA) 9 \nB) 7 \nC) 5 \nD) 4 \nE) 3",
    "alternativas": {
      "C": "5",
      "E": "3",
      "A": "9",
      "B": "7"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 638,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0639",
    "numero": 2139,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma pesquisa de mercado foi realizada entre os \nconsumidores das classes sociais A, B, C e D \nque costumam participar de promoções tipo \nsorteio ou concurso. Os dados comparativos, \nexpressos no gráfico, revelam a participação \ndesses consumidores em cinco categorias: via \nCorreios (juntando embalagens ou recortando \ncódigos de barra), via internet (cadastrando-se \nno site da empresa/marca promotora), via mí-\ndias sociais (redes sociais), via SMS (mensa-\ngem por celular) ou via rádio/Tv. \n \n \n \nUma empresa vai lançar uma promoção utili-\nzando apenas uma categoria nas classes A e B \n(A/B) e uma categoria nas classes C e D (C/D). \nDe acordo com o resultado da pesquisa, para \natingir o maior número de consumidores das \nclasses A/B e C/D, a empresa deve realizar a \npromoção, respectivamente, via \n \nA) Correios e SMS, \nB) internet e Correios. \nC) internet e internet. \nD) internet e mídias sociais. \nE) rádio/TV e rádio/TV.",
    "alternativas": {
      "B": "internet e Correios.",
      "C": "internet e internet.",
      "D": "internet e mídias sociais.",
      "A": "Correios e SMS,"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 639,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0640",
    "numero": 2140,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Uma fábrica de sorvetes utiliza embalagens \nplásticas no formato de paralelepípedo retangu-\nlar reto. Internamente, a embalagem tem 10 cm \nde altura e base de 20 cm por 10 cm. No pro-\ncesso de confecção do sorvete, uma mistura é \ncolocada na embalagem no estado líquido e, \nquando levada ao congelador, tem seu volume \naumentado em 25%, ficando com consistência \ncremosa. \n \nInicialmente é colocada na embalagem uma \nmistura sabor chocolate com volume de 1000 \ncm3 e, após essa mistura ficar cremosa, será \nadicionada uma mistura sabor morango, de \nmodo que, ao final do processo de congelamen-\nto, a embalagem fique completamente preen-\nchida com sorvete, sem transbordar. \n \nO volume máximo, em cm3, da mistura sabor \nmorango que deverá ser colocado na embala-\ngem é: \n \nA) 450.  \nB) 500.  \nC) 600.  \nD) 750.  \nE) 1000.",
    "alternativas": {
      "D": "750.",
      "E": "1000.",
      "B": "500.",
      "C": "600."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 640,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0641",
    "numero": 2141,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Em uma central de atendimento, cem pessoas \nreceberam senhas numeradas de 1 até 100. \nUma das senhas é sorteada ao acaso.  \n \nQual é a probabilidade de a senha sorteada ser \num número de 1 a 20? \n \nA) 1/100 \nB) 19/100 \nC) 20/100 \nD) 21/100 \nE) 80/100",
    "alternativas": {
      "E": "80/100",
      "A": "1/100",
      "C": "20/100",
      "D": "21/100"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 641,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0642",
    "numero": 2142,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O Esquema I mostra a configuração de uma quadra de basquete. Os trapézios em cinza, chamados de \ngarrafões, correspondem a áreas restritivas. \n \n \n \nVisando atender as orientações do Comitê Central da Federação Internacional de Basquete (Fiba) em \n2010, que unificou as marcações das diversas ligas, foi prevista uma modificação nos garrafões das \nquadras, que passariam a ser retângulos, como mostra o Esquema II. \nApós executadas as modificações previstas, houve uma alteração na área ocupada por cada garrafão, \nque corresponde a um(a): \n \nA) aumento de 5800 cm2. \nB) aumento de 75400 cm2. \nC) aumento de 214600 cm2. \nD) diminuição de 63800 cm2. \nE) diminuição de 272600 cm2.",
    "alternativas": {
      "B": "aumento de 75400 cm2.",
      "D": "diminuição de 63800 cm2.",
      "E": "diminuição de 272600 cm2.",
      "A": "aumento de 5800 cm2."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 642,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0643",
    "numero": 2143,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Em uma seletiva para a final dos 100 metros livres de natação, numa olimpíada, os atletas, em suas \nrespectivas raias, obtiveram os seguintes tempos: \n \n \n \nA mediana dos tempos apresentados no quadro é: \n \nA) 20,70.  \n \nB) 20,77.  \nC) 20,80. \nD) 20,85.  \nE) 20,90.",
    "alternativas": {
      "D": "20,85.",
      "A": "20,70.",
      "B": "20,77.",
      "C": "20,80."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 643,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0644",
    "numero": 2144,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "O gerente de um cinema fornece anualmente \ningressos gratuitos para escolas. Este ano se-\nrão distribuídos 400 ingressos para uma sessão \nvespertina e 320 ingressos para uma sessão \nnoturna de um mesmo filme. Várias escolas \npodem ser escolhidas para receberem ingres-\nsos. Há alguns critérios para a distribuição dos \ningressos: \n \n1) cada escola deverá receber ingressos \npara uma única sessão; \n2) todas as escolas contempladas deverão \nreceber o mesmo número de ingressos; \n3) não haverá sobra de ingressos (ou seja, \ntodos os ingressos serão distribuídos). \n \nO número mínimo de escolas que podem ser \nescolhidas para obter ingressos, segundo os \ncritérios estabelecidos, é: \n \nA) 2. \nB) 4. \nC) 9. \nD) 40. \nE) 80.",
    "alternativas": {
      "B": "4.",
      "C": "9.",
      "D": "40.",
      "A": "2."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2015.1",
    "numeroOriginal": 644,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];